import Popup from 'reactjs-popup';

interface Props {
  users?: string[] | null;
}

export default function RoleUsersPopup({ users }: Props) {
  const count = users?.length ?? 0;
  return (
    <Popup
      trigger={<div className="text-white fs-6 d-block cursor-pointer">{count}</div>}
      position="top center"
      on="hover"
    >
      <div
        className="d-flex flex-column bg-primary rounded-2 p-2 gap-1 overflow-y-auto customScrollbar-Y"
        style={{ minWidth: 160, maxHeight: 200 }}
      >
        {(users ?? []).length > 0 ? (
          (users ?? []).map((u) => (
            <div key={u} className="text-white text-break">
              {u}
            </div>
          ))
        ) : (
          <div className="text-white">No users</div>
        )}
      </div>
    </Popup>
  );
}
